export default {"src":"/_next/static/media/Lightning-Fast.79240b0c.svg","height":135,"width":171};